<template>
  <crud-update :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @update="update"
               @close="$emit('close')"
  >
    <surveys-form ref="form" v-model="form" :input-errors="inputErrors" @save="update"/>
  </crud-update>
</template>

<script>

import SurveysProvider from "../../../../providers/SurveysProvider";

import {CrudUpdate, ClientError} from '@dracul/common-frontend'

import SurveysForm from "../../../../forms/SurveysForm";


export default {
  name: "SurveyUpdate",

  components: {SurveysForm, CrudUpdate},

  props: {
    open: {type: Boolean, default: true},
    item: {type: Object, required: true}
  },

  data() {
    return {
      title: 'delivery.surveys.editing',
      errorMessage: '',
      inputErrors: {},
      loading: false,
      id: this.item.id,
      form: {
        name: this.item.name,
        description: this.item.description,
        questions: this.item.questions,
      }
    }
  },
  methods: {
    update() {
      if (this.validate()) {
        this.loading = true
        SurveysProvider.updateSurvey(this.id, this.form).then(r => {
              if (r) {
                this.$emit('itemUpdated', r.data.updatePromo)
                this.$emit('close')
              }
            }
        ).catch(error => {
          let clientError = new ClientError(error)
          this.inputErrors = clientError.inputErrors
          this.errorMessage = clientError.i18nMessage
        }).finally(() => this.loading = false)
      }
    },
    validate(){
      if(!this.$refs.form?.validate()) return false
      if(!this.form.questions.length) return false
      for(const question of this.form.questions) {
        if(!question.question) return false
        if(question.options.length < 2) return false
        for(const option of question.options){
          if(!option.value) return false
        }
      }
      return true
    }
  },
}
</script>

<style scoped>

</style>

